import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ChannelCreate from './ChannelCreate/ChannelCreate';
import ChannelsList from './ChannelsList/ChannelsList';
import ChannelEdit from './ChannelEdit/ChannelEdit';
import ChannelDelete from './ChannelDelete/ChannelDelete';

const Channels = ({ match }) => {
    return (
        <div className="Channels">
            <ContainerWrapper container="post_categories">
                <Route exact path={ match.path } component={ChannelsList} />
                <Route exact path={ `${ match.url }/new` } component={ChannelCreate} />
                <Route exact path={ `${ match.url }/edit/:channelId` } component={ChannelEdit} />
                <Route exact path={ `${ match.url }/delete/:channelId` } component={ChannelDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Channels;
